
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcElevatedCard as ObcElevatedCardElement} from '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';
 
 
 

 
 export const ObcElevatedCard = createComponent({
   react: React,
   tagName: 'obc-elevated-card',
   elementClass: ObcElevatedCardElement,
   events: {
     
     onActionClick: 'action-click' as EventName<CustomEvent<unknown>>,
   }
  });
 
 